import React from 'react';


class Footer extends React.Component {
  render() {
		
  	return (
        <div>
        <div id="fb-root"></div>
            <footer className="cpoy-right-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <div className="theme-footer">
                                <div className="row">
                                    <div className="col-md-3">
                                        <ul>
                                            <li><a href={`${process.env.PUBLIC_URL}/abstract-botany`}>Abstract Botany</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/abstract-faces`}>Abstract Faces</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/abstract-landmarks`}>Abstract Landmarks</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/beaches`}>Beaches</a></li>
                                        </ul>
                                    </div>
                                    <div className="col-md-3">
                                        <ul>
                                            <li><a href={`${process.env.PUBLIC_URL}/city-houses`}>City Houses</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/constellations`}>Constellations</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/cute-puzzle-animals`}>Cute Puzzle Animals</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/geometric-arts`}>Geometric Arts</a></li>
                                        </ul>
                                    </div>
                                    <div className="col-md-3">
                                        <ul>
                                            <li><a href={`${process.env.PUBLIC_URL}/geometric-shapes`}>Geometric Shapes</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/house-plants`}>House Plants</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/landscapes`}>Landscapes</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/playful-abstractions`}>Playful Abstractions</a></li>
                                        </ul>
                                    </div>
                                    <div className="col-md-3">
                                        <ul>
                                            <li><a href={`${process.env.PUBLIC_URL}/puzzle`}>Puzzle</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/shapes`}>Shapes</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/sun`}>Sun</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/zodiac-signs`}>Zodiac Signs</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="social-footer">
                                <ul>
                                    <li><a href={null}  dangerouslySetInnerHTML={{ __html: '<i class="fa fa-twitter" aria-hidden="true"></i>' }}></a></li>
                                    <li><a href={null}  dangerouslySetInnerHTML={{ __html: '<i class="fa fa-instagram" aria-hidden="true"></i>' }}></a></li>
                                    <li><a href={null} dangerouslySetInnerHTML={{ __html: '<i class="fa fa-pinterest" aria-hidden="true"></i>' }}></a></li>
                                    <li><a href={null} dangerouslySetInnerHTML={{ __html: '<i class="fa fa-youtube" aria-hidden="true"></i>' }}></a></li>
                                </ul>
                            </div> */}
                        </div>
                        <div className="col-md-12 text-center">
                            <p className="copyright">{(new Date().getFullYear())} Copyright by Omoboto LLC</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
  	);
  }
}


export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js